
var orig_allowInteraction = $.ui.dialog.prototype._allowInteraction;
$.ui.dialog.prototype._allowInteraction = function(event) {
    // address interaction issues with general iframes with the dialog
    if (event.target.ownerDocument != this.document[0]) {
        return true;
    }
    // address interaction issues with dialog window
    if ($(event.target).closest(".cke_dialog").length) {
        return true;
    }
    // address interaction issues with iframe based drop downs in IE
    if ($(event.target).closest(".cke").length) {
        return true;
    }
    return orig_allowInteraction.apply(this, arguments);
}

// Main navigation
// Open mobile menu
jQuery(once('tgc-btnmenu-click', 'body')).on('click', '.btn-menu', function (e) {
    e.preventDefault();
    jQuery('#tgcmainnavigation').toggleClass('nav-open');
    jQuery('.lnk-hub').toggleClass('nav-open');
    jQuery('.mobile-social-links').toggleClass('nav-open');
    jQuery('.header-wrap').toggleClass('menu-open');
    jQuery('.menu-item-has-sub').removeClass('sub-menu-open');
    jQuery(this).toggleAttrVal('aria-expanded', 'true', 'false');
    jQuery(".menu-child-sub-open").removeClass('menu-child-sub-open');
});

// Sub menu dropdown in main nav
jQuery(once('tgc-menu-click', 'body')).on('click', '.menu-lnk-has-sub', function (e) {
    e.preventDefault();
    if(jQuery(this).parent().hasClass('sub-menu-open')) {
        jQuery(this).parent().removeClass('sub-menu-open');
        jQuery(this).parent().parent().removeClass('menu-child-sub-open');
        jQuery(this).attr('aria-expanded', 'false');
        jQuery(this).parent().find('.sub-menu').attr('aria-hidden', 'true');
        jQuery('body').removeClass('sub-menu-open');
    } else {
        jQuery('.sub-menu-open').removeClass('sub-menu-open');
        jQuery('.sub-menu').attr('aria-hidden', 'true');
        jQuery('.menu-lnk-has-sub').attr('aria-expanded', 'false');
        jQuery(this).parent().addClass('sub-menu-open');
        jQuery(this).parent().parent().addClass('menu-child-sub-open');
        jQuery(this).attr('aria-expanded', 'true');
        jQuery(this).parent().find('.sub-menu').attr('aria-hidden', 'false');
        jQuery('body').addClass('sub-menu-open');
    }
});

jQuery('#user-login-form .form-item-pass').append('<button type="button" class="btn-pwd-view">View/Hide</button>');

jQuery(once('tgc-pwd-show', 'body')).on('click', '.btn-pwd-view', function (e) {
    e.preventDefault();
    jQuery('#edit-pass').toggleAttrVal('type', 'password', 'text');
    jQuery(this).toggleClass('btn-pwd-hide');
});

jQuery('.menu-lnk-has-sub').on('keypress', function (e){
    if(e.which == 13){
        jQuery('.menu-item-has-sub .menu-lnk').trigger('click');
    }
});

jQuery('.content-wrap').on('click', function (e) {
    jQuery('.sub-menu-open').removeClass('sub-menu-open');
    jQuery('.menu').removeClass('menu-open');
});


// Video descriptions
jQuery(once('toggle-videodesc', 'body')).on('click', '.video-desc-head', function (e) {
    e.preventDefault();
    $(this).next().slideToggle('fast').toggleAttrVal('aria-hidden', 'true', 'false');
    $(this).prev().toggleClass('icon-plus');
    $(this).prev().toggleClass('icon-minus');
});

jQuery(once('cookie-dismiss', 'body')).on('click', '.eu-cookie-compliance-default-button', function (e) {
    e.preventDefault();
});

// Toggle attribute
jQuery.fn.toggleAttr = function(attr, val) {
    var test = jQuery(this).attr(attr);
    if ( test ) {
        jQuery(this).removeAttr(attr);
    } else {
        jQuery(this).attr(attr, val);
    }
    return this;
};

// Toggle attribute value
jQuery.fn.toggleAttrVal = function(attr, val1, val2) {
    var test = jQuery(this).attr(attr);
    if ( test === val1) {
        jQuery(this).attr(attr, val2);
        return this;
    }
    if ( test === val2) {
        jQuery(this).attr(attr, val1);
        return this;
    }

    jQuery(this).attr(attr, val1);
    return this;
};

// Cookie notice trap
jQuery(window).on('load', function () {
    if (jQuery('.eu-cookie-compliance-more-button').length) {
        jQuery('.eu-cookie-compliance-more-button').focus();
    }
});
jQuery(once('se-cookietrap', 'body')).on('keydown', '.eu-cookie-compliance-default-button', function (e) {
    if (e.keyCode === 9) {
        e.preventDefault();
        jQuery('.eu-cookie-compliance-more-button').focus();
    }
});

jQuery('.webform-button--submit').click(function(){
    setTimeout(function() {   //calls click event after a certain time
        if (jQuery('.form-error').length < 1) {
            $('html, body').animate({
                scrollTop: jQuery('.webform-submission-form').offset().top - 100
            }, 500);
        }
    }, 1500);
});

jQuery('.image-library-form-actions .form-submit').click(function(){
    setTimeout(function() {   //calls click event after a certain time
            $('html, body').animate({
                scrollTop: jQuery('.views-infinite-scroll-content-wrapper').offset().top - 200
            }, 500);
    }, 1500);
});
